const SITE_URL = "https://unihaul.vercel.app";

export function ensureMeta(name) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.name = name;
    document.head.appendChild(el);
  }
  return el;
}

export function ensureProperty(prop) {
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  return el;
}

export function setMeta(name, content) {
  ensureMeta(name).content = content;
}

export function setProperty(prop, content) {
  ensureProperty(prop).content = content;
}

export function setTitle(title) {
  document.title = title;
  const description = document.querySelector('meta[name="description"]')?.content || "";
  setProperty("og:title", title);
  setProperty("og:url", `${SITE_URL}${location.pathname}`);
  if (description) setProperty("og:description", description);
}

export function setJSONLD(data, id) {
  document.getElementById(id)?.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function removeJSONLD(id) {
  document.getElementById(id)?.remove();
}
